/**
 * Returns every text node under `root`, in document order.
 *
 * @param root - The node to walk.
 * @param accept - Optional predicate; only text nodes for which it returns
 *   `true` are included.
 */
export function textNodes(root: Node, accept?: (node: Text) => boolean): Text[] {
  const filter: NodeFilter | undefined = accept
    ? {
      acceptNode: (node) =>
        accept(node as Text) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT,
    }
    : undefined;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, filter);

  const nodes: Text[] = [];
  let node: Node | null;
  while ((node = walker.nextNode())) {
    nodes.push(node as Text);
  }
  return nodes;
}
